<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div
      class="modal-body"
      :class="{ 'load load--full': loading }"
    >
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="mt-0 font-bold"
          v-text="`Editing ${folderTitle}`"
        />
      </header>
      <div class="mt-4">
        <label
          for="edit-folder-title"
          v-text="'Title'"
        />
        <input
          id="edit-folder-title"
          v-model="title"
          type="text"
          name="edit-folder-title"
          class="input"
          placeholder="Title"
        >
      </div>
      <div
        v-if="loading"
        v-text="'LOADING POTENTIAL PARENTS'"
      />
      <div v-if="!loading">
        <label
          for="edit-folder-parent-folder"
          v-text="'Parent folder'"
        />
        <Multiselect
          id="edit-folder-parent-folder"
          v-model="parentFolder"
          :options="potentialParentFolders"
          label="title"
          track-by="uuid"
          placeholder="Select folder"
          open-direction="bottom"
          :allow-empty="false"
        >
          <template
            slot="option"
            slot-scope="props"
          >
            <div class="option__desc">
              <span class="option__title">
                <span
                  v-for="index in props.option.level"
                  :key="`option-${index}`"
                  class="text-grey"
                >
                  &ndash;
                </span>
                {{ props.option.title }}
              </span>
            </div>
          </template>
        </Multiselect>
      </div>
    </div>
    <div
      v-if="!loading"
      class="flex justify-center items-baseline modal-footer text-center mt-4"
    >
      <button
        type="button"
        class="btn"
        @click="save"
        v-text="'Save'"
      />
      <a
        href="#"
        class="mx-4"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import Multiselect from 'vue-multiselect'

export default {
  name: 'EditFolderModal',
  components: {
    Multiselect,
  },
  data() {
    return {
      loading: false,
      title: '',
      parentFolder: null,
      potentialParentFolders: [],
    }
  },
  computed: {
    folderTitle() {
      return this.folder ? this.folder.attributes.title : ''
    },
    show() {
      return this.$store.state.document.editFolderModal.open
    },
    folder() {
      return this.$store.state.document.editFolderModal.folder
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.title = this.folder.attributes.title
        this.loading = true

        this.$store.dispatch('documentGetFolderTree').then(() => {
          this.populatePotentialParentFolders()
        })
      }
    },
  },
  methods: {
    populatePotentialParentFolders() {
      const vm = this

      // Allow for a way to move to a Root Folder
      const root = [
        {
          level: 0,
          title: 'Top Level Folder',
          prefixedTitle: 'Top Level Folder',
          uuid: null,
        },
      ]

      // Get all folders for organization
      const folderTree = vm.$store.getters.flatFolderTree

      // Preset an the parent folder
      vm.parentFolder = _.find(folderTree, { uuid: _.get(vm.folder.parent, 'uuid') })

      if (!vm.parentFolder) {
        vm.parentFolder = root[0]
      }

      // Find which items are descendants of the current folder
      const descendantUuids = _.flatMap(_.get(vm.folder, 'descendants.data'), 'uuid')

      // Mark descendants as invalid so they can't be used
      vm.potentialParentFolders = root.concat(
        _.map(folderTree, function (folder) {
          const index = _.findIndex(descendantUuids, function (descendantUuid) {
            return descendantUuid === folder.uuid
          })

          if (index > -1 || folder.uuid === vm.folder.uuid) {
            folder.$isDisabled = true
          }

          return folder
        })
      )

      this.loading = false
    },
    calculateClass(level) {
      const margin = {
        1: 'ml-2',
        2: 'ml-4',
        3: 'ml-6',
        4: 'ml-10',
        5: 'ml-12',
      }

      return level > 1 ? `text-grey-darker ${margin[level]}` : ''
    },
    save() {
      if (!this.title) {
        return
      }

      this.$api
        .active()
        .put(`folders/${this.folder.uuid}`, {
          title: this.title,
          parentUuid: this.parentFolder.uuid,
        })
        .then(() => {
          this.$emit('folderHasBeenUpdated')

          this.$store.commit('baseAddNotification', {
            type: 'success',
            title: 'Success',
            text: 'Folder updated!',
          })

          this.close()
        })
    },
    close() {
      this.loading = false
      this.title = ''
      this.parentFolder = null
      this.potentialParentFolders = []

      this.$store.commit('documentCloseEditFolderModal')
    },
  },
}
</script>
